import { InputTextarea } from "primereact/inputtextarea";

import { FormField } from "@/ds";

import {
  JUSTIFICATIVA_LABEL,
  JUSTIFICATIVA_REQUIRED_HINT,
} from "../inativar-papel-obra-dialog/inativar-papel-obra-dialog.constants";
import styles from "./conflito-justificativa.module.scss";
import type { ConflitoJustificativaViewModel } from "./types-conflito-justificativa";

export function ConflitoJustificativaView({
  id,
  value,
  error,
  disabled,
  divided,
  testId,
  errorTestId,
  maxLength,
  hideRequiredHint,
  placeholder,
  digitar,
}: ConflitoJustificativaViewModel) {
  return (
    <FormField.Root
      id={id}
      error={error}
      className={divided ? styles.divided : undefined}
      disabled={disabled}
    >
      <div className={styles.labelRow}>
        <FormField.Label>{JUSTIFICATIVA_LABEL}</FormField.Label>
        {hideRequiredHint ? null : (
          <span className={styles.hint}>{JUSTIFICATIVA_REQUIRED_HINT}</span>
        )}
      </div>
      <FormField.Control>
        <InputTextarea
          value={value}
          placeholder={placeholder}
          rows={3}
          autoResize={false}
          maxLength={maxLength}
          onChange={(event) => digitar(event.currentTarget.value)}
          required
          aria-required
          data-testid={testId}
        />
      </FormField.Control>
      <FormField.Error data-testid={errorTestId} />
    </FormField.Root>
  );
}
